import './TableModifier.scss';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FilterDisplay } from './FilterDisplay';
import { FilterMenu } from './FilterMenu';
import { objectKeys } from '@sonar-software/sonar-ts-lib';
import { SortedBySelect } from './SortedBy';
import { TableOutlined } from '@ant-design/icons';
import { translateFilterAndOrderingToQueryParams } from './@arch/lib';
import { When } from 'react-if';
import { Button, Row } from 'antd';
import { ColumnsModal } from './ColumnsModal';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useBoolean } from '@hooks';
export const TableModifier = ({ allowColumnConfig, className, convertToDynamicQueryLanguage, convertToQueryParams = translateFilterAndOrderingToQueryParams, columns = [], columnsString, customArrangers, extra, filters, filtersString, filterDisplayType, onChange, orderString, sonarObjectId, sonarObjectType, sortOptions }) => {
    const [showColumnsModal, handleSetColumnsModal] = useBoolean(false);
    const [filterParams, setFilterParams] = useState(() => convertToQueryParams(filters, sortOptions, filtersString, orderString));
    const onChangeRef = useRef(onChange);
    onChangeRef.current = onChange;
    useEffect(() => {
        const newFilterParams = convertToQueryParams(filters, sortOptions, filtersString, orderString);
        setFilterParams(newFilterParams);
    }, [convertToQueryParams, filters, filtersString, orderString, sortOptions]);
    const handleUpdate = useCallback((update) => {
        let newParams;
        if (objectKeys(update).length) {
            newParams = Object.assign(Object.assign({}, filterParams), update);
        }
        else {
            newParams = Object.assign(Object.assign({}, filterParams), { filterCount: 0 });
            filters.forEach((filter) => {
                newParams[filter.filterId].value =
                    Array.isArray(newParams[filter.filterId].value) ? [] : undefined;
            });
        }
        setFilterParams(newParams);
        const dql = convertToDynamicQueryLanguage === null || convertToDynamicQueryLanguage === void 0 ? void 0 : convertToDynamicQueryLanguage(newParams);
        if (dql) {
            onChangeRef.current(filterParams.sortBy ? dql : { filters: dql.filters });
        }
    }, [convertToDynamicQueryLanguage, filterParams, filters]);
    const showFilterMenu = filterDisplayType === 'menu';
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: classNames('table-modifier', { 'with-menu': showFilterMenu }, className) },
            React.createElement("div", { className: 'filters' }, filters === null || filters === void 0 ? void 0 :
                filters.map((filter) => React.createElement(FilterDisplay, { displayAsTag: showFilterMenu, filter: filter, filterParams: filterParams, key: filter.filterId, sonarObjectId: sonarObjectId, sonarObjectType: sonarObjectType, updateFilterParams: handleUpdate })),
                React.createElement(When, { condition: showFilterMenu && Boolean(filterParams.filterCount) },
                    React.createElement(Button, { onClick: () => handleUpdate({}), size: 'small', type: 'link' }, COPY_SPECIFIC.CLEAR_ALL))),
            React.createElement("div", { className: 'arrangers' },
                customArrangers,
                allowColumnConfig &&
                    React.createElement(Button, { icon: React.createElement(TableOutlined, null), onClick: handleSetColumnsModal.on, type: 'text' }, COPY_SPECIFIC.COLUMNS),
                React.createElement(When, { condition: showFilterMenu },
                    React.createElement(FilterMenu, { filterParams: filterParams, filters: filters, sonarObjectId: sonarObjectId, sonarObjectType: sonarObjectType, updateFilterParams: handleUpdate })),
                React.createElement(SortedBySelect, { defaultValue: filterParams.sortDefault || sortOptions[0], onChange: handleUpdate, queryParams: filterParams, sortOptions: sortOptions }),
                extra)),
        React.createElement(When, { condition: allowColumnConfig },
            React.createElement(ColumnsModal, { columns: columns, columnsString: columnsString, onCancel: handleSetColumnsModal.off, onChange: onChange, open: showColumnsModal }))));
};
